export default {
  curriculum_filename: '' 
}